import { SmartfireComponent, smartProps } from '@smartfire/gutenberg-react';
import './style.scss';
import CapsaTitle from '../CapsaTitle/block.js';
import SliderArrows from '../shared/SliderArrows.js';
import ReadMoreButton from '../shared/ReadMoreButton.js';
import BackgroundSlider from '../shared/BackgroundSlider.js';
import BackgroundGrid from '../shared/BackgroundGrid.js';
import React from 'react';
import { SelectControl, PanelBody, Button } from '@wordpress/components';
import {
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid/Grid';
import { Fragment } from '@wordpress/element';
import { MediaUpload, PlainText } from '@wordpress/editor';

export default class TextImageBlock extends SmartfireComponent {
    static title = 'Bloc Images + Textes';

    static smartProps = {
        image1Url: smartProps.string.isRequired,
        title1: smartProps.string.isRequired,
        description1: smartProps.string.isRequired,
        url1: smartProps.string.isRequired,
        image2Url: smartProps.string.isRequired,
        title2: smartProps.string.isRequired,
        description2: smartProps.string.isRequired,
        url2: smartProps.string.isRequired,
        image3Url: smartProps.string.isRequired,
        title3: smartProps.string.isRequired,
        description3: smartProps.string.isRequired,
        url3: smartProps.string.isRequired,

        containerBgColor: smartProps.any.withDefault(''),
        imagePosition: smartProps.any.withDefault(''),
        filterImage: smartProps.any.withDefault(''),
        bgColor: smartProps.any.withDefault('bg-white'),
        imageHigher: smartProps.any.withDefault(''),
        titleLocation: smartProps.any.withDefault('inside'),
        textOverflow: smartProps.any.withDefault(''),
        proportion: smartProps.any.withDefault(''),
        arrowsColor: smartProps.any.withDefault(''),
        containerWidth: smartProps.any.withDefault(''),
        gridColor: smartProps.any.withDefault('grid-grey'),
        titleTag: smartProps.any.withDefault('h2'),
        gridConfig: smartProps.any.withDefault('config1'),
    };

    constructor(props) {
        super(props);
        this.state = {
            articles: [],
            currentArticle: null,
            containerHeight: 0,
        };
        this.backgroundSlider = React.createRef();
        this.textCol = React.createRef();
        this.imageCol = React.createRef();
        this.container = React.createRef();
        this.updateDimensions = this.updateDimensions.bind(this);
    }
    componentDidMount() {
        this.updateDimensions();
        window.addEventListener('load', this.updateDimensions);
        window.addEventListener('resize', this.updateDimensions);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.updateDimensions();
    }

    updateDimensions = () => {
        if (!this.textCol.current || !this.imageCol.current) return;

        let heightDiff = Math.abs(
            this.textCol.current.getBoundingClientRect().top -
                this.imageCol.current.getBoundingClientRect().top,
        );
        if (this.props.imageHigher === 'image-bigger') {
            let newHeight = this.textCol.current.clientHeight + heightDiff * 2;
            this.imageCol.current.style.height = newHeight + 'px';
            this.container.current.style.height = newHeight + 'px';
        } else {
            let newHeight = this.textCol.current.clientHeight;
            this.imageCol.current.style.height = newHeight + 'px';
            this.container.current.style.height = newHeight + heightDiff + 'px';
        }
    };

    componentWillMount() {
        let articles = [];
        if (this.props.image1Url && this.props.description1 !== '') {
            articles.push({
                title: this.props.title1,
                description: this.props.description1,
                url: this.props.url1,
                resource: { url: this.props.image1Url },
            });
        }

        if (this.props.image2Url && this.props.description2 !== '') {
            articles.push({
                title: this.props.title2,
                description: this.props.description2,
                url: this.props.url2,
                resource: { url: this.props.image2Url },
            });
        }

        if (this.props.image3Url && this.props.description3 !== '') {
            articles.push({
                title: this.props.title3,
                description: this.props.description3,
                url: this.props.url3,
                resource: { url: this.props.image3Url },
            });
        }

        this.setState({ articles, currentArticle: articles[0] });
    }

    goToPrevSlide = () => {
        let newIndex = this.backgroundSlider.current.goToPrevSlide();
        this.setState({ currentArticle: this.state.articles[newIndex] });
    };

    goToNextSlide = () => {
        let newIndex = this.backgroundSlider.current.goToNextSlide();
        this.setState({ currentArticle: this.state.articles[newIndex] });
    };

    renderEditInspector() {
        return (
            <Fragment>
                <PanelBody title={SmartfireComponent.__('Disposition générale')}>
                    <SelectControl
                        label="Couleur de fond de page"
                        value={this.props.containerBgColor}
                        options={[
                            { label: 'Blanc', value: 'bg-white' },
                            { label: 'Gris', value: 'bg-grey' },
                            { label: 'Bleu', value: 'bg-blue' },
                        ]}
                        onChange={(containerBgColor) => {
                            this.setAttributes({ containerBgColor: containerBgColor });
                        }}
                    />
                    <SelectControl
                        label="Largeur conteneur"
                        value={this.props.containerWidth}
                        options={[
                            { label: '100%', value: '' },
                            { label: '90% collé à gauche', value: 'pull-left' },
                            { label: '90% collé à droite', value: 'pull-right' },
                        ]}
                        onChange={(containerWidth) => {
                            this.setAttributes({ containerWidth: containerWidth });
                        }}
                    />
                    <SelectControl
                        label="Proportion des zones texte/image"
                        value={this.props.proportion}
                        options={[
                            { label: '33/66', value: 'width-33-66' },
                            { label: '45/55', value: 'width-45-55' },
                            { label: '50/50', value: '' },
                            { label: '55/45', value: 'width-55-45' },
                            { label: '66/33', value: 'width-66-33' },
                        ]}
                        onChange={(proportion) => {
                            this.setAttributes({ proportion: proportion });
                        }}
                    />
                    <SelectControl
                        label="Position de l'image"
                        value={this.props.imagePosition}
                        options={[
                            { label: 'A gauche', value: '' },
                            { label: 'A droite', value: 'image-right' },
                        ]}
                        onChange={(imagePosition) => {
                            this.setAttributes({ imagePosition: imagePosition });
                        }}
                    />
                    <SelectControl
                        label="Filtre sur l'image"
                        value={this.props.filterImage}
                        options={[
                            { label: 'Transparent', value: 'filterTransparent' },
                            { label: 'Bleu', value: 'filterBlue' },
                        ]}
                        onChange={(filterImage) => {
                            this.setAttributes({ filterImage: filterImage });
                        }}
                    />
                </PanelBody>
                <PanelBody title={SmartfireComponent.__('Zone texte')}>
                    <SelectControl
                        label="Position du titre"
                        value={this.props.titleLocation}
                        options={[
                            { label: 'Dans la zone texte', value: 'inside' },
                            { label: 'En dehors de la zone texte', value: 'outside' },
                        ]}
                        onChange={(titleLocation) => {
                            this.setAttributes({ titleLocation: titleLocation });
                        }}
                    />
                    <SelectControl
                        label="Couleur de fond de la zone texte"
                        value={this.props.bgColor}
                        options={[
                            { label: 'Blanc', value: 'bg-white' },
                            { label: 'Gris', value: 'bg-grey' },
                            { label: 'Bleu', value: 'bg-blue' },
                        ]}
                        onChange={(bgColor) => {
                            this.setAttributes({ bgColor: bgColor });
                        }}
                    />
                    <SelectControl
                        label="La zone texte est plus haute que l'image"
                        value={this.props.imageHigher}
                        options={[
                            { label: 'Oui', value: '' },
                            { label: 'Non', value: 'image-higher' },
                            { label: 'Non + image plus grande', value: 'image-bigger' },
                        ]}
                        onChange={(imageHigher) => {
                            this.setAttributes({ imageHigher: imageHigher });
                        }}
                    />
                    <SelectControl
                        label="La zone texte dépasse sur l'image"
                        value={this.props.textOverflow}
                        options={[
                            { label: 'Non', value: '' },
                            { label: 'Oui', value: 'text-overflow' },
                        ]}
                        onChange={(textOverflow) => {
                            this.setAttributes({ textOverflow: textOverflow });
                        }}
                    />
                </PanelBody>
                <PanelBody title={SmartfireComponent.__('Couleurs flèches')}>
                    <SelectControl
                        label="Couleurs flèches"
                        value={this.props.arrowsColor}
                        options={[
                            { label: 'G: bleu - D: bleu', value: '' },
                            { label: 'G: blanc - D: bleu', value: 'arrow-l-white' },
                            { label: 'G: bleu - D: blanc', value: 'arrow-r-white' },
                        ]}
                        onChange={(arrowsColor) => {
                            this.setAttributes({ arrowsColor: arrowsColor });
                        }}
                    />
                </PanelBody>
                <PanelBody title={SmartfireComponent.__('Grille')}>
                    <SelectControl
                        label="Config grille"
                        value={this.props.gridConfig}
                        options={[
                            { label: 'Config 1', value: 'config1' },
                            { label: 'Config 2', value: 'config2' },
                            { label: 'Config 3', value: 'config3' },
                            { label: 'Config 4', value: 'config4' },
                            { label: 'Config 5 (sans grille)', value: 'config5' },
                        ]}
                        onChange={(gridConfig) => {
                            this.setAttributes({ gridConfig: gridConfig });
                        }}
                    />
                    <SelectControl
                        label="Couleur grille"
                        value={this.props.gridColor}
                        options={[
                            { label: 'Gris', value: 'grid-grey' },
                            { label: 'Bleu', value: 'grid-blue' },
                        ]}
                        onChange={(gridColor) => {
                            this.setAttributes({ gridColor: gridColor });
                        }}
                    />
                </PanelBody>
                <PanelBody title={SmartfireComponent.__('SEO')}>
                    <SelectControl
                        label="Hn"
                        value={this.props.titleTag}
                        options={[
                            { label: 'H2', value: 'h2' },
                            { label: 'p', value: 'p' },
                        ]}
                        onChange={(titleTag) => {
                            this.setAttributes({ titleTag: titleTag });
                        }}
                    />
                </PanelBody>
            </Fragment>
        );
    }

    render() {
        console.log(this.props.titleTag);

        if (this.isEditing) {
            const getImageButton = (openEvent) => {
                if (this.props.image1Url) {
                    return (
                        <div>
                            <Button
                                onClick={() => {
                                    this.setAttributes({ image1Url: '' });
                                }}
                                className="button button-large"
                            >
                                {' '}
                                Supprimer l'image{' '}
                            </Button>
                            <div
                                className="image"
                                style={{
                                    backgroundImage: 'url(' + this.props.image1Url + ')',
                                }}
                                onClick={openEvent}
                            />
                        </div>
                    );
                } else {
                    return (
                        <div className="image">
                            <div className="button-container">
                                <Button
                                    onClick={openEvent}
                                    className="button button-large"
                                >
                                    {' '}
                                    Sélectionner une image{' '}
                                </Button>
                            </div>
                        </div>
                    );
                }
            };

            const getImage2Button = (openEvent) => {
                if (this.props.image2Url) {
                    return (
                        <div>
                            <Button
                                onClick={() => {
                                    this.setAttributes({ image2Url: '' });
                                }}
                                className="button button-large"
                            >
                                {' '}
                                Supprimer l'image{' '}
                            </Button>
                            <div
                                className="image"
                                style={{
                                    backgroundImage: 'url(' + this.props.image2Url + ')',
                                }}
                                onClick={openEvent}
                            />
                        </div>
                    );
                } else {
                    return (
                        <div className="image">
                            <div className="button-container">
                                <Button
                                    onClick={openEvent}
                                    className="button button-large"
                                >
                                    {' '}
                                    Sélectionner une image{' '}
                                </Button>
                            </div>
                        </div>
                    );
                }
            };

            const getImage3Button = (openEvent) => {
                if (this.props.image3Url) {
                    return (
                        <div>
                            <Button
                                onClick={() => {
                                    this.setAttributes({ image3Url: '' });
                                }}
                                className="button button-large"
                            >
                                {' '}
                                Supprimer l'image{' '}
                            </Button>
                            <div
                                className="image"
                                style={{
                                    backgroundImage: 'url(' + this.props.image3Url + ')',
                                }}
                                onClick={openEvent}
                            />
                        </div>
                    );
                } else {
                    return (
                        <div className="image">
                            <div className="button-container">
                                <Button
                                    onClick={openEvent}
                                    className="button button-large"
                                >
                                    {' '}
                                    Sélectionner une image{' '}
                                </Button>
                            </div>
                        </div>
                    );
                }
            };

            return (
                <div className="admin-text-image-block">
                    <p>Renseignez entre 1 et 3 diapositives</p>

                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            Zone Texte + Image
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Grid container spacing={24}>
                                <Grid item xs={5}>
                                    <MediaUpload
                                        onSelect={(media) => {
                                            this.setAttributes({ image1Url: media.url });
                                        }}
                                        type="image"
                                        value={this.props.image1ID}
                                        render={({ open }) => getImageButton(open)}
                                    />
                                </Grid>
                                <Grid item xs={7}>
                                    <PlainText
                                        onChange={(content) =>
                                            this.setAttributes({ title1: content })
                                        }
                                        value={this.props.title1}
                                        placeholder="Titre Diapo 1"
                                        className="heading title"
                                    />
                                    <PlainText
                                        onChange={(content) =>
                                            this.setAttributes({ description1: content })
                                        }
                                        value={this.props.description1}
                                        placeholder="Description Diapo 1"
                                        className="description"
                                    />
                                    <PlainText
                                        onChange={(content) =>
                                            this.setAttributes({ url1: content })
                                        }
                                        value={this.props.url1}
                                        placeholder="URL Diapo 1"
                                        className="description"
                                    />
                                </Grid>
                            </Grid>
                        </ExpansionPanelDetails>

                        <ExpansionPanelDetails>
                            <Grid container spacing={24}>
                                <Grid item xs={5}>
                                    <MediaUpload
                                        onSelect={(media) => {
                                            this.setAttributes({ image2Url: media.url });
                                        }}
                                        type="image"
                                        value={this.props.image2ID}
                                        render={({ open }) => getImage2Button(open)}
                                    />
                                </Grid>
                                <Grid item xs={7}>
                                    <PlainText
                                        onChange={(content) =>
                                            this.setAttributes({ title2: content })
                                        }
                                        value={this.props.title2}
                                        placeholder="Titre Diapo 2"
                                        className="heading title"
                                    />
                                    <PlainText
                                        onChange={(content) =>
                                            this.setAttributes({ description2: content })
                                        }
                                        value={this.props.description2}
                                        placeholder="Description Diapo 2"
                                        className="description"
                                    />
                                    <PlainText
                                        onChange={(content) =>
                                            this.setAttributes({ url2: content })
                                        }
                                        value={this.props.url2}
                                        placeholder="URL Diapo 2"
                                        className="description"
                                    />
                                </Grid>
                            </Grid>
                        </ExpansionPanelDetails>

                        <ExpansionPanelDetails>
                            <Grid container spacing={24}>
                                <Grid item xs={5}>
                                    <MediaUpload
                                        onSelect={(media) => {
                                            this.setAttributes({ image3Url: media.url });
                                        }}
                                        type="image"
                                        value={this.props.image3ID}
                                        render={({ open }) => getImage3Button(open)}
                                    />
                                </Grid>
                                <Grid item xs={7}>
                                    <PlainText
                                        onChange={(content) =>
                                            this.setAttributes({ title3: content })
                                        }
                                        value={this.props.title3}
                                        placeholder="Titre Diapo 3"
                                        className="heading title"
                                    />
                                    <PlainText
                                        onChange={(content) =>
                                            this.setAttributes({ description3: content })
                                        }
                                        value={this.props.description3}
                                        placeholder="Description Diapo 3"
                                        className="description"
                                    />
                                    <PlainText
                                        onChange={(content) =>
                                            this.setAttributes({ url3: content })
                                        }
                                        value={this.props.url3}
                                        placeholder="URL Diapo 3"
                                        className="description"
                                    />
                                </Grid>
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
            );
        } else {
            let hasSlider = this.state.articles.length > 1 ? 'has-slider' : '';

            return (
                <div>
                    <div
                        className={
                            'image-text-block ' +
                            this.props.imagePosition +
                            ' ' +
                            this.props.proportion +
                            ' ' +
                            this.props.imageHigher +
                            ' ' +
                            this.props.containerWidth +
                            ' ' +
                            this.props.containerBgColor +
                            ' ' +
                            hasSlider
                        }
                    >
                        <div className="content-container">
                            {this.props.titleLocation === 'outside' &&
                                this.props.bgColor === 'bg-white' && (
                                    <CapsaTitle
                                        title={this.nl2br(
                                            this.state.currentArticle.title,
                                        )}
                                        bg="grey"
                                        position="left"
                                        type={this.props.titleTag}
                                    />
                                )}
                            {this.props.titleLocation === 'outside' &&
                                this.props.bgColor === 'bg-blue' && (
                                    <CapsaTitle
                                        title={this.nl2br(
                                            this.state.currentArticle.title,
                                        )}
                                        bg="light-blue"
                                        position="left"
                                        type={this.props.titleTag}
                                    />
                                )}
                            {this.props.titleLocation === 'outside' &&
                                this.props.bgColor === 'bg-grey' && (
                                    <CapsaTitle
                                        title={this.nl2br(
                                            this.state.currentArticle.title,
                                        )}
                                        bg="white"
                                        position="left"
                                        type={this.props.titleTag}
                                    />
                                )}

                            <div
                                className="image-text-block-container"
                                ref={this.container}
                            >
                                <div className="image-col" ref={this.imageCol}>
                                    {this.state.articles.length > 1 &&
                                        !this.props.imagePosition && (
                                            <SliderArrows
                                                goToPrevSlide={this.goToPrevSlide}
                                                goToNextSlide={this.goToNextSlide}
                                                color={this.props.arrowsColor}
                                            />
                                        )}
                                    <BackgroundSlider
                                        slides={this.state.articles}
                                        ref={this.backgroundSlider}
                                        filterImage={this.props.filterImage}
                                    />
                                </div>
                                <div
                                    className={
                                        'text-col ' +
                                        this.props.bgColor +
                                        ' ' +
                                        this.props.textOverflow
                                    }
                                    ref={this.textCol}
                                >
                                    <div className="description">
                                        {this.props.titleLocation === 'inside' &&
                                            this.state.currentArticle.title &&
                                            this.props.bgColor === 'bg-white' && (
                                                <CapsaTitle
                                                    title={this.nl2br(
                                                        this.state.currentArticle.title,
                                                    )}
                                                    bg="grey"
                                                    position="left"
                                                    type={this.props.titleTag}
                                                />
                                            )}
                                        {this.props.titleLocation === 'inside' &&
                                            this.state.currentArticle.title &&
                                            this.props.bgColor === 'bg-grey' && (
                                                <CapsaTitle
                                                    title={this.nl2br(
                                                        this.state.currentArticle.title,
                                                    )}
                                                    bg="white"
                                                    position="left"
                                                    type={this.props.titleTag}
                                                />
                                            )}
                                        {this.props.titleLocation === 'inside' &&
                                            this.state.currentArticle.title &&
                                            this.props.bgColor === 'bg-blue' && (
                                                <CapsaTitle
                                                    title={this.nl2br(
                                                        this.state.currentArticle.title,
                                                    )}
                                                    text="white"
                                                    bg="light-blue"
                                                    position="left"
                                                    type={this.props.titleTag}
                                                />
                                            )}
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: this.nl2br(
                                                    this.state.currentArticle.description,
                                                ),
                                            }}
                                        />
                                        {this.state.currentArticle.url ? (
                                            <ReadMoreButton
                                                url={this.state.currentArticle.url}
                                                color={
                                                    this.props.bgColor === 'bg-blue'
                                                        ? 'white'
                                                        : 'blue'
                                                }
                                            />
                                        ) : null}
                                    </div>

                                    {this.props.gridConfig !== '' &&
                                        this.props.gridConfig !== 'config5' && (
                                            <div className={this.props.gridConfig}>
                                                <BackgroundGrid
                                                    color={
                                                        this.props.gridColor ===
                                                        'grid-grey'
                                                            ? 'grey'
                                                            : 'blue'
                                                    }
                                                />
                                            </div>
                                        )}

                                    {this.state.articles.length > 1 &&
                                        this.props.imagePosition && (
                                            <SliderArrows
                                                goToPrevSlide={this.goToPrevSlide}
                                                goToNextSlide={this.goToNextSlide}
                                                color={this.props.arrowsColor}
                                            />
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ clear: 'both' }} />
                </div>
            );
        }
    }

    nl2br(str) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = '<br />';
        return (str + '').replace(
            /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
            '$1' + breakTag + '$2',
        );
    }
}
